import { ReactComponent as Close } from "../../img/Close.svg";
import { ReactComponent as Sparkle } from "../../img/Sparkle.svg";

const HARDCODED_ACCESS_END_DATE = "April 1, 2026";

interface CancelBrilliantMaxModalProps {
  closeCancelBrilliantMaxModal: () => void;
  homeName: string;
}

const CancelBrilliantMaxModal: React.FC<CancelBrilliantMaxModalProps> = ({
  closeCancelBrilliantMaxModal,
  homeName,
}) => {
  return (
    <div className="popup-background">
      <div className="modal-create-container">
        <div className="modal-header">
          <div className="modal-title-container">
            <Sparkle
              className="modal-header-img cancel-bmx-modal-sparkle"
              title="Sparkle"
            />
            <div className="unit-title">
              Cancel Brilliant Max:{" "}
              <span className="cancel-bmx-modal-title-name">{homeName}</span>
            </div>
          </div>
          <Close
            className="modal-header-img"
            onClick={closeCancelBrilliantMaxModal}
            title="Close modal"
          />
        </div>

        <div className="modal-create-body">
          <div className="cancel-bmx-modal-info-card">
            Once confirmed, this home&apos;s subscription will remain active
            until the end of the current billing period.
          </div>

          <div className="cancel-bmx-modal-table margin-top-small">
            <span className="cancel-bmx-modal-table-header sub-heading">
              Home Name
            </span>
            <span className="cancel-bmx-modal-table-header sub-heading">
              Access will end on
            </span>
            <span className="cancel-bmx-modal-table-value tool-tip">
              {homeName}
            </span>
            <span className="cancel-bmx-modal-table-date tool-tip">
              {HARDCODED_ACCESS_END_DATE}
            </span>
          </div>

          <div className="cancel-bmx-modal-actions margin-top-small">
            <button
              className="tertiary-btn-small tertiary-btn-small-alert"
              type="button"
              onClick={closeCancelBrilliantMaxModal}
            >
              Go Back
            </button>
            <button
              className="tertiary-btn-small tertiary-btn-small-main tertiary-btn-small-main-alert"
              type="button"
              onClick={() => {}}
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelBrilliantMaxModal;
